import { render, staticRenderFns } from "./ServiceModuleReports.html?vue&type=template&id=06379dce&scoped=true&external"
import script from "./ServiceModuleReports.js?vue&type=script&lang=js&external"
export * from "./ServiceModuleReports.js?vue&type=script&lang=js&external"
import style0 from "./ServiceModuleReports.scss?vue&type=style&index=0&id=06379dce&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06379dce",
  null
  
)

export default component.exports